import { Box, Space } from "@gocardless/flux-react";
import { i18n } from "@lingui/core";
import { t } from "@lingui/macro";
import {
  CreditorBankAccountResource,
  SchemeIdentifier,
} from "@gocardless/api/dashboard/types";

import AdditionalCurrency from "../features/additional-currency/AdditionalCurrency";
import SectionHeader from "../features/section-header/SectionHeader";

import { Currency } from "src/common/currencies";

interface AdditionalCurrenciesSectionProps {
  showPrimaryBankForm: boolean;
  primaryAccount?: CreditorBankAccountResource;
  showAddAdditionalBanks: boolean;
  additionalAccounts: Record<string, CreditorBankAccountResource>;
  schemeIdentifierCurrencies: SchemeIdentifier;
  refreshSetup: () => void;
}
export const AdditionalCurrenciesSection: React.FC<
  AdditionalCurrenciesSectionProps
> = ({
  showPrimaryBankForm,
  primaryAccount,
  showAddAdditionalBanks,
  additionalAccounts,
  schemeIdentifierCurrencies,
  refreshSetup,
}) => (
  <Box>
    {!showPrimaryBankForm && primaryAccount && <Space v={2} />}
    {showAddAdditionalBanks && (
      <SectionHeader
        title={i18n._(
          t({
            id: "setup.bank-details.add-another-currency-bank-account",
            message: "Add another currency bank account (optional)",
          })
        )}
      />
    )}
    {!showPrimaryBankForm && primaryAccount && <Space v={3} />}

    {Object.entries(schemeIdentifierCurrencies).map(([currency, country]) => (
      <Box key={currency}>
        <AdditionalCurrency
          country={country}
          currency={currency as Currency}
          bankDetails={additionalAccounts[currency]}
          handleUpdate={() => refreshSetup()}
        />
      </Box>
    ))}
  </Box>
);
